import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import React, { useCallback, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from '../checkbox/checkbox';
import { useDropdown } from '../dropdown';
import { context } from './utils';
import s from './select.module.css';
import { handleKeyPressEnter } from '../../utils/handle-keypress-enter';
import { getStringFromReactNode } from '../../utils/get-string-from-react-node';
var Option = function Option(_ref) {
  var value = _ref.value,
    children = _ref.children,
    _ref$checkbox = _ref.checkbox,
    checkbox = _ref$checkbox === void 0 ? true : _ref$checkbox,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? false : _ref$divider,
    externalDataTest = _ref.dataTest,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected;
  var _useDropdown = useDropdown(),
    toggle = _useDropdown.toggle;
  var _useContext = useContext(context),
    mode = _useContext.mode,
    onChange = _useContext.onChange,
    contextDataTest = _useContext.dataTest;
  var _useState = useState(selected),
    _useState2 = _slicedToArray(_useState, 2),
    check = _useState2[0],
    setCheck = _useState2[1];
  var handleClick = useCallback(function (event) {
    var update = mode === 'standalone' ? false : !check;
    setCheck(update);
    onChange(value, update, event);
    if (mode !== 'multiple') {
      toggle();
    }
  }, [value, mode, toggle, onChange, check]);
  useEffect(function () {
    return setCheck(selected);
  }, [selected]);
  var attrs = Object.assign(Object.assign(Object.assign({
    'data-option': ''
  }, (contextDataTest || externalDataTest) && {
    'data-test': contextDataTest ? "".concat(contextDataTest, "-option:").concat(value) : externalDataTest
  }), check && {
    'data-selected': ''
  }), disabled ? {
    'data-disabled': ''
  } : {
    onClick: handleClick,
    onKeyPress: handleKeyPressEnter(handleClick),
    role: 'button',
    tabIndex: 0
  });
  return React.createElement("div", Object.assign({
    className: classNames(s.option, divider && s.divider, mode === 'multiple' && s.multiple)
  }, attrs), mode === 'multiple' && checkbox && React.createElement("div", {
    className: s.checkbox
  }, React.createElement(Checkbox, {
    value: check,
    disabled: disabled
  })), React.createElement("div", {
    className: s.content
  }, children));
};
var NativeOption = function NativeOption(_ref2) {
  var value = _ref2.value,
    children = _ref2.children,
    selected = _ref2.selected,
    disabled = _ref2.disabled,
    dataTest = _ref2.dataTest;
  var _useContext2 = useContext(context),
    setNativeValue = _useContext2.setNativeValue;
  useEffect(function () {
    if (selected) {
      setNativeValue(value);
    }
  }, [setNativeValue, value, selected]);
  return React.createElement("option", Object.assign({
    value: value,
    disabled: disabled,
    "data-test": dataTest
  }, typeof value === 'number' && {
    'data-int': ''
  }), getStringFromReactNode(children));
};
var SelectOption = function SelectOption(_a) {
  var props = __rest(_a, []);
  var _useContext3 = useContext(context),
    native = _useContext3.native;
  return native ? React.createElement(NativeOption, Object.assign({}, props)) : React.createElement(Option, Object.assign({}, props));
};
export default SelectOption;